export default __webpack_public_path__ + "dist/media/MinusWhite.af460501.svg";